{
  "app.name": "NIMER Engagement Scoping Portal",
  "app.shortName": "NIMER",
  "chapter.APP": "Applications",
  "chapter.CFG": "Configuration review",
  "chapter.CLD": "Cloud",
  "chapter.CMB": "Combined scope",
  "chapter.EPT": "Endpoints",
  "chapter.GEN.about": "About you",
  "chapter.GEN.logistics": "Logistics",
  "chapter.GEN.needs": "Your needs",
  "chapter.IDN": "Identity",
  "chapter.INF": "Infrastructure",
  "chapter.OTX": "Operational technology",
  "chapter.VUL": "Vulnerability assessment",
  "chapter.WLS": "Wireless",
  "chapter.review": "Review and submit",
  "chooser.answered": "{count} answered",
  "chooser.bringColleagues": "Bring in colleagues",
  "chooser.continueAnswering": "Continue answering",
  "chooser.created": "Started {date}",
  "chooser.currentEngagement": "Currently open",
  "chooser.duplicate.failed": "That flag could not be recorded. Mention it to your consultant instead.",
  "chooser.duplicate.open": "Looks like a duplicate",
  "chooser.duplicate.prompt": "Which engagement is {ref} a duplicate of? A NIMER consultant decides which one is kept; nothing is closed automatically.",
  "chooser.duplicate.sent": "Flagged. A consultant will look at it.",
  "chooser.engagementHome": "Engagement home",
  "chooser.engagementNav": "This engagement",
  "chooser.error": "Your engagements could not be loaded.",
  "chooser.eyebrow": "Signed in",
  "chooser.flagDuplicate": "This looks like a duplicate",
  "chooser.heading": "Your engagements",
  "chooser.inProgress": "In progress",
  "chooser.intro": "Choose the engagement you want to work on. You can move between them at any time.",
  "chooser.noServiceYet": "Service not yet chosen",
  "chooser.none": "You have no open engagements.",
  "chooser.noneHint": "An engagement you were on may have closed. If you were expecting one here, reply to the invitation email you received and a NIMER consultant will check.",
  "chooser.notStarted": "Not started",
  "chooser.open": "Open",
  "chooser.origin.consultant": "Set up by NIMER",
  "chooser.origin.leadConversion": "From your enquiry",
  "chooser.origin.selfServe": "Started by you",
  "chooser.progressLabel": "Progress",
  "chooser.reference": "Reference {ref}",
  "chooser.roleContributor": "You are contributing",
  "chooser.roleLabel": "Your role",
  "chooser.roleOwner": "You own this",
  "chooser.stateLabel": "Status",
  "chooser.submitted": "Submitted",
  "chooser.switchEngagement": "Switch engagement",
  "chooser.unavailable": "That engagement could not be opened. Choose one below.",
  "chooser.unknownEngagement": "No engagement selected",
  "chooser.waitingOnYou": "{count} waiting on you",
  "chooser.withConsultant": "With your consultant",
  "chooser.workingOn": "Working on",
  "chooser.youAreHere": "You are here",
  "collab.answeredBy": "Answered by {name}",
  "collab.colAnswered": "Answered",
  "collab.colForwarded": "Waiting on",
  "collab.colNotSure": "Not sure",
  "collab.colSection": "Section",
  "collab.forward": "Forward",
  "collab.forwardCancel": "Cancel",
  "collab.forwardCount": "{count} question(s) will be forwarded.",
  "collab.forwardEmail": "Their email address",
  "collab.forwardExplainer": "They sign in with their own email and answer only what you send.",
  "collab.forwardFailed": "The forward did not go through. Please try again.",
  "collab.forwardName": "Their name (optional)",
  "collab.forwardNote": "A note for them (optional — never include passwords or keys)",
  "collab.forwardSection": "Forward {count} unanswered",
  "collab.forwardSectionTip": "Send every still-unanswered question in this section to a colleague. They sign in with their own email and answer only what you send.",
  "collab.forwardSend": "Forward",
  "collab.forwardSomeoneNew": "Someone new…",
  "collab.forwardTip": "Send just this question to a colleague. They sign in with their own email and answer only what you send.",
  "collab.forwardTitle": "Forward to a colleague",
  "collab.forwardWho": "Who should answer these?",
  "collab.forwardedTo": "Forwarded to {name}",
  "collab.invite": "Invite a colleague",
  "collab.inviteBody": "They sign in with their own email and can answer any open question. You stay the owner — only you can submit.",
  "collab.inviteFailed": "The invitation could not be sent. Please try again.",
  "collab.inviteTitle": "Invite a colleague.",
  "collab.neverSignedIn": "Invited — has not signed in yet",
  "collab.nudge": "Re-send invitation",
  "collab.ownerBadge": "(owner)",
  "collab.peopleHeading": "People",
  "collab.personTally": "{answered} answered · waiting on {waiting}",
  "collab.progressError": "Progress could not be loaded. Please try again.",
  "collab.progressEyebrow": "Your engagement",
  "collab.progressHeading": "Questionnaire progress",
  "collab.progressSummary": "{answered} of {total} questions answered.",
  "collab.revoke": "Remove access",
  "collab.revokeBody": "{name} will no longer be able to sign in to this engagement. Answers they have already given stay on the record.",
  "collab.revokeTitle": "Remove access?",
  "collab.sectionsHeading": "Sections",
  "collab.stalled": "{count} waiting more than 3 days",
  "collab.stat.answered": "questions answered",
  "collab.stat.notSure": "marked not sure",
  "collab.stat.waiting": "waiting on colleagues",
  "confirm.eyebrow": "Before you begin",
  "confirm.failed": "That could not be saved. Check the fields and try again.",
  "confirm.heading": "Confirm your details",
  "confirm.intro": "A NIMER consultant set this engagement up. Check what they have, and fill in anything missing.",
  "confirm.known": "What we already have",
  "confirm.loadFailed": "Your details could not be loaded just now. This is a problem at our end, not with your account.",
  "confirm.missing": "Anything missing",
  "confirm.retry": "Try again",
  "confirm.submit": "Confirm and continue",
  "confirm.workEmail": "Work email",
  "confirmScope.confidence": "{percent}% confidence",
  "confirmScope.confirm": "Yes, in scope",
  "confirmScope.decline": "No, not this time",
  "confirmScope.empty": "We could not identify a service from your answers yet. Go back and complete the remaining questions, or ask your consultant to take a look.",
  "confirmScope.eyebrow": "Before we size it",
  "confirmScope.intro": "From your answers so far, these are the services we think your engagement needs. Confirm the ones that belong in scope — we only ask sizing questions about those, so this is what keeps the rest of the questionnaire short.",
  "confirmScope.noneChosen": "Confirm at least one service, or ask your consultant to review the scope with you.",
  "confirmScope.notSure": "I'm not sure",
  "confirmScope.notSureNote": "Anything you are unsure about goes to your consultant — it is never dropped and never guessed.",
  "confirmScope.pending": "Confirming…",
  "confirmScope.railTitle": "Confirm scope",
  "confirmScope.submit": "Confirm and continue",
  "confirmScope.title": "Does this look like the right work?",
  "delegate.alreadyInvited": "Already invited",
  "delegate.areaOf": "Part of {chapter}",
  "delegate.assignPlaceholder": "colleague@yourcompany.com",
  "delegate.assignTo": "Send to",
  "delegate.assignWhole": "Send all of this to",
  "delegate.back": "Back",
  "delegate.chapterAssign": "Give each area to whoever knows it best. They only see what you send them, and you can still answer anything yourself.",
  "delegate.coveredBy": "Covered by whoever gets this area",
  "delegate.error": "This could not be loaded.",
  "delegate.eyebrow": "Step 1 of 2",
  "delegate.guide.about.name": "About your organisation",
  "delegate.guide.about.what": "Your organisation — size, sector, and where you operate.",
  "delegate.guide.about.who": "You, or whoever keeps company details.",
  "delegate.guide.app.name": "Applications and APIs",
  "delegate.guide.app.what": "Your websites, mobile apps and APIs — how people sign in and what they can do once they are in.",
  "delegate.guide.app.who": "Whoever owns the application: a product owner, your lead developer, or the supplier who built it.",
  "delegate.guide.cfg.name": "System configuration",
  "delegate.guide.cfg.what": "How your firewalls, servers, databases and network equipment are set up.",
  "delegate.guide.cfg.who": "Whoever administers those systems — usually your infrastructure team.",
  "delegate.guide.cld.name": "Cloud accounts",
  "delegate.guide.cld.what": "Your Microsoft Azure, Amazon AWS or Google Cloud accounts, and who controls them.",
  "delegate.guide.cld.who": "Whoever holds the cloud accounts and pays the cloud bill.",
  "delegate.guide.cmb.name": "Which areas apply",
  "delegate.guide.cmb.what": "Which of these areas apply to you, when the work covers several.",
  "delegate.guide.cmb.who": "You, alongside whoever knows your systems best.",
  "delegate.guide.ept.name": "Laptops and servers",
  "delegate.guide.ept.what": "Laptops, desktops and servers, and the security software installed on them.",
  "delegate.guide.ept.who": "Whoever runs IT support or manages company laptops.",
  "delegate.guide.idn.name": "Staff accounts and access",
  "delegate.guide.idn.what": "Staff accounts and passwords — how people join, leave, and get extra access.",
  "delegate.guide.idn.who": "Whoever administers Microsoft 365 or Active Directory.",
  "delegate.guide.inf.name": "Networks",
  "delegate.guide.inf.what": "Your networks: what is reachable from the internet, and how the inside is divided up.",
  "delegate.guide.inf.who": "Whoever looks after your network.",
  "delegate.guide.logistics.name": "Timing and logistics",
  "delegate.guide.logistics.what": "When we may test, who we may contact, and how findings should reach you.",
  "delegate.guide.logistics.who": "Whoever will run this day to day — often an IT or project manager.",
  "delegate.guide.needs.name": "Why you are doing this",
  "delegate.guide.needs.what": "Why this engagement is happening: the deadline, and the customer, insurer or auditor asking for it.",
  "delegate.guide.needs.who": "You, or whoever owns the contract or the obligation behind it.",
  "delegate.guide.otx.name": "Operational technology",
  "delegate.guide.otx.what": "Machinery and control systems — the equipment that runs a plant, line or facility.",
  "delegate.guide.otx.who": "Your engineering, plant or operations lead. This is usually not IT.",
  "delegate.guide.vul.name": "Vulnerability scanning",
  "delegate.guide.vul.what": "What should be scanned for known weaknesses, and whether the scan may sign in to do it.",
  "delegate.guide.vul.who": "Whoever handles patching and updates.",
  "delegate.guide.wls.name": "Wi-Fi",
  "delegate.guide.wls.what": "Your Wi-Fi, and how staff, guests and devices connect to it.",
  "delegate.guide.wls.who": "Whoever manages your Wi-Fi — usually the network team.",
  "delegate.heading": "Bring in colleagues",
  "delegate.nothingLeft": "Everything is either answered or already with someone.",
  "delegate.nowAnswer": "Answer the rest myself",
  "delegate.openCount": "{count} questions open",
  "delegate.sendInvites": "Send invitations",
  "delegate.sentBody": "They will each get an email with only the questions you sent them.",
  "delegate.sentEyebrow": "Invitations sent",
  "delegate.sentHeading": "Invitations sent to {count} people",
  "delegate.skipToQuestions": "Answer everything myself",
  "delegate.splitClose": "Send the whole area to one person",
  "delegate.splitOpen": "Send parts to different people",
  "delegate.whoAnswers": "Usually answered by",
  "discovery.discover.error": "Something went wrong. Please try again.",
  "discovery.discover.fact": "{factKey}: {value}",
  "discovery.discover.heading": "Tell us what you need, and we'll work it out with you",
  "discovery.discover.hint": "Describe your situation in your own words. We'll ask a few follow-up questions and suggest what the engagement should cover.",
  "discovery.discover.remaining": "{remaining} more exchange(s) in this conversation.",
  "discovery.discover.submit": "Send",
  "discovery.discover.submitting": "Sending…",
  "discovery.discover.terminated": "That's enough to get started — the questions below now reflect what you told us.",
  "discovery.discover.terminatedCallback": "Thanks — this one needs a person. A consultant will call you back to finish scoping it, and you can carry on with the questions below in the meantime.",
  "discovery.interpret.error": "Something went wrong reading that. Please try again.",
  "discovery.interpret.fact": "{factKey}: {value}",
  "discovery.interpret.heading": "Describe what you need assessed",
  "discovery.interpret.hint": "Type a short description in your own words — we'll suggest what applies.",
  "discovery.interpret.submit": "Send",
  "discovery.interpret.submitting": "Sending…",
  "entry.cmbSelection.heading": "Which areas should the engagement cover?",
  "entry.cmbSelection.option.apis": "APIs",
  "entry.cmbSelection.option.applicationsPortals": "Applications and portals",
  "entry.cmbSelection.option.cloud": "Cloud environments",
  "entry.cmbSelection.option.configurationReviews": "Configuration reviews",
  "entry.cmbSelection.option.endpoints": "Endpoints",
  "entry.cmbSelection.option.everythingHelpMeScope": "Everything — help me work out the scope",
  "entry.cmbSelection.option.externalInfrastructure": "Internet-facing infrastructure",
  "entry.cmbSelection.option.identityAd": "Identity — Active Directory and Entra ID",
  "entry.cmbSelection.option.internalNetwork": "The internal network",
  "entry.cmbSelection.option.mobileApps": "Mobile apps",
  "entry.cmbSelection.option.otIndustrial": "OT and industrial systems",
  "entry.cmbSelection.option.vulnerabilityScanning": "Vulnerability scanning",
  "entry.cmbSelection.option.wireless": "Wireless networks",
  "entry.door.start": "Request a scoping call",
  "entry.error": "Something went wrong loading your questionnaire. Please reload the page.",
  "entry.eyebrow": "Start a conversation",
  "entry.footer.brand": "NIMER Pro / GCC Cybersecurity / 2026",
  "entry.footer.contact": "info@nimer.pro",
  "entry.footer.site": "www.nimer.pro",
  "entry.footer.staff": "NIMER staff sign-in",
  "entry.heading": "Tell us what you need",
  "entry.how.1.body": "A few details about your organisation and what you are trying to achieve.",
  "entry.how.1.title": "Tell us what you need",
  "entry.how.2.body": "A NIMER consultant reviews your enquiry and gets in touch to understand the detail.",
  "entry.how.2.title": "A consultant reads it",
  "entry.how.3.body": "The consultant creates the engagement and invites you into the portal.",
  "entry.how.3.title": "We set up your engagement",
  "entry.how.4.body": "You answer what only you can answer, and confirm the scope before anything is priced.",
  "entry.how.4.title": "You confirm the scope",
  "entry.how.note": "A consultant responds within one business day.",
  "entry.how.title": "How this works",
  "entry.intro": "You do not need to know which security service is required. Describe what you are trying to achieve, and a NIMER consultant will set up a scoping request tailored to it.",
  "entry.lead.back": "Back",
  "entry.lead.country": "Country",
  "entry.lead.email": "Work email",
  "entry.lead.failed": "Your enquiry could not be sent. Please try again.",
  "entry.lead.heading": "Request a scoping call",
  "entry.lead.interest": "What are you interested in?",
  "entry.lead.interestHint": "Optional. Search for a service, or leave it to the consultant.",
  "entry.lead.intro": "Tell us what you are trying to achieve. A NIMER consultant will get in touch.",
  "entry.lead.message": "What do you need?",
  "entry.lead.messageHint": "Describe what you are trying to achieve. You do not need to name a service.",
  "entry.lead.optional": "Optional",
  "entry.lead.orgName": "Organisation",
  "entry.lead.phone": "Phone",
  "entry.lead.sending": "Sending…",
  "entry.lead.sentBody": "A NIMER consultant will contact you within one business day.",
  "entry.lead.sentEyebrow": "Enquiry received",
  "entry.lead.sentHeadline": "Thank you — your enquiry is with us.",
  "entry.lead.sentWhatNext": "There is nothing else to do here. If your enquiry becomes an engagement, the consultant will invite you into the portal by email.",
  "entry.lead.submit": "Send enquiry",
  "entry.lead.yourName": "Your name",
  "entry.line.advisory.description": "Executive cyber leadership, board reporting, governance design, vCISO retainers.",
  "entry.line.advisory.label": "Advisory & CISO-as-a-Service",
  "entry.line.aiSec.description": "AI/LLM threat modelling, agent governance, AI-safe enterprise operations.",
  "entry.line.aiSec.label": "AI & Agentic Computing Security",
  "entry.line.archStrategy.description": "Security vision, target operating model, architecture and multi-year roadmaps.",
  "entry.line.archStrategy.label": "Enterprise Security Architecture & Strategy",
  "entry.line.assessment.description": "Penetration testing, vulnerability assessment, configuration review, red team and OT/ICS assessment.",
  "entry.line.assessment.label": "Security Assessment & Testing",
  "entry.line.grc.description": "Regulatory alignment, audit readiness and certification support (NCA ECC, SAMA CSF, ISO 27001, IEC 62443, SOC 2, PDPL).",
  "entry.line.grc.label": "Risk, Compliance & Assurance",
  "entry.line.infraSec.description": "Zero Trust design, secure cloud migration, network and enterprise infrastructure hardening.",
  "entry.line.infraSec.label": "Infrastructure & Cloud Security",
  "entry.line.otIcs.description": "Industrial control system security programmes beyond point-in-time assessment.",
  "entry.line.otIcs.label": "OT / ICS Cybersecurity Programmes",
  "entry.line.secOps.description": "SOC design and build, managed detection & response, incident response retainers.",
  "entry.line.secOps.label": "Security Operations & Monitoring",
  "entry.lines.note": "Not sure which one you need? Describe it in your own words and the portal will narrow it down.",
  "entry.lines.title": "What you can scope here",
  "entry.mode.continue": "Continue",
  "entry.mode.customer": "I work for the organisation requesting this",
  "entry.mode.endCustomerContactVisible": "May we contact the end customer directly for technical clarification?",
  "entry.mode.endCustomerOrg": "End-customer organisation",
  "entry.mode.fieldRequired": "This field is required.",
  "entry.mode.partnerContact": "Partner contact",
  "entry.mode.partnerOnBehalf": "I am a partner submitting on behalf of a customer",
  "entry.mode.partnerOrg": "Partner organisation",
  "entry.mode.partnerRef": "Partner reference / opportunity ID",
  "entry.mode.pricingVisibility.endCustomerVisible": "Visible to the end customer as well",
  "entry.mode.pricingVisibility.label": "Should commercial pricing be visible to the end customer?",
  "entry.mode.pricingVisibility.partnerOnly": "Visible to the partner only",
  "entry.mode.whiteLabel": "Should deliverables carry partner branding (white-label)?",
  "entry.mode.who": "Who is submitting this request?",
  "entry.opening.branch.app": "Applications",
  "entry.opening.branch.cld": "Cloud",
  "entry.opening.branch.idn": "Identity",
  "entry.opening.branch.inf": "Infrastructure",
  "entry.opening.branch.wls": "Wireless",
  "entry.opening.eyebrow": "Your needs",
  "entry.opening.heading": "What would you like us to assess?",
  "entry.opening.helper": "Choose everything that applies — the questionnaire adapts to your selection.",
  "entry.opening.option.apisOrIntegrationServices": "APIs or integration services",
  "entry.opening.option.auditOrComplianceRequirement": "I am responding to an audit/compliance requirement",
  "entry.opening.option.cloudEnvironment": "Cloud environment",
  "entry.opening.option.identityEnvironment": "Active Directory / identity environment",
  "entry.opening.option.mobileApplication": "A mobile application",
  "entry.opening.option.multipleSystemsOrEntireEnvironment": "Multiple systems / entire environment",
  "entry.opening.option.notSure": "I am not sure",
  "entry.opening.option.serversOrNetworkInfrastructure": "Servers or network infrastructure",
  "entry.opening.option.websitePortalApplication": "A website, portal or application",
  "entry.opening.option.wirelessNetwork": "Wireless network",
  "entry.org.contact": "Primary contact",
  "entry.org.orgName": "Organisation name",
  "entry.pick.freeTextLabel": "Anything else we should know? (optional)",
  "entry.pick.groupAssessment": "Security Assessment & Testing",
  "entry.pick.heading": "What do you need help with?",
  "entry.pick.noResults": "Nothing matched. Pick the closest service line below, and describe what you need in the box underneath.",
  "entry.pick.searchPlaceholder": "Search — e.g. pentest, ISO 27001, SOC, vCISO…",
  "entry.returning.action": "Sign in to continue",
  "entry.returning.prompt": "Already started a request?",
  "entry.who.country": "Country / location of the organisation",
  "entry.who.country.ae": "United Arab Emirates",
  "entry.who.country.bh": "Bahrain",
  "entry.who.country.kw": "Kuwait",
  "entry.who.country.om": "Oman",
  "entry.who.country.other": "Another country",
  "entry.who.country.qa": "Qatar",
  "entry.who.country.sa": "Saudi Arabia",
  "entry.who.emailHint": "We send a sign-in code to this email if your request continues into the online questionnaire.",
  "entry.who.emailInvalid": "Enter a valid email address.",
  "entry.who.eyebrow": "About you",
  "entry.who.heading": "Tell us about your organisation",
  "entry.who.phoneInvalid": "Enter a phone number with country code, e.g. +974 5555 1234.",
  "entry.who.sector": "Industry sector",
  "entry.who.sector.bankingFinance": "Banking & financial services",
  "entry.who.sector.education": "Education",
  "entry.who.sector.energyOilGas": "Energy, oil & gas",
  "entry.who.sector.government": "Government & public sector",
  "entry.who.sector.healthcare": "Healthcare",
  "entry.who.sector.manufacturing": "Manufacturing",
  "entry.who.sector.other": "Another sector",
  "entry.who.sector.retail": "Retail & consumer",
  "entry.who.sector.technology": "Technology & software",
  "entry.who.sector.telecom": "Telecommunications",
  "entry.who.sector.transport": "Transport & logistics",
  "entry.who.sector.utilities": "Utilities (power, water)",
  "entry.who.size": "Organisation size",
  "entry.who.size.emp1001to5000": "1,001–5,000 employees",
  "entry.who.size.emp1to50": "1–50 employees",
  "entry.who.size.emp251to1000": "251–1,000 employees",
  "entry.who.size.emp5000plus": "More than 5,000 employees",
  "entry.who.size.emp51to250": "51–250 employees",
  "loadFailure.retry": "Try again",
  "loadFailure.retrying": "Trying…",
  "loading": "Loading…",
  "loading.attachmentUpload": "Uploading…",
  "loading.attachments": "Loading documents…",
  "loading.checkingCode": "Checking your sign-in code…",
  "loading.confirmScope": "Confirming scope…",
  "loading.details": "Loading your details…",
  "loading.engagement": "Opening this engagement…",
  "loading.engagements": "Finding your engagements…",
  "loading.forwarding": "Sending those questions to your colleague…",
  "loading.generic": "Working on it…",
  "loading.interpreting": "Reading your description and preparing suggestions…",
  "loading.invite": "Sending the invitation…",
  "loading.page": "Loading this page…",
  "loading.progress": "Gathering the latest progress from your team…",
  "loading.questionnaire": "Loading your questionnaire and saved answers…",
  "loading.queue": "Loading the queue…",
  "loading.revoke": "Removing access…",
  "loading.sendingCode": "Emailing you a sign-in code…",
  "notFound.body": "The page you asked for is not here. If you followed a link from an email, it may have expired.",
  "notFound.heading": "Page not found",
  "notFound.home": "Go to the start",
  "owner.actionAnswer": "Answer the questions myself",
  "owner.actionBoth": "Bring in colleagues, then answer the rest",
  "owner.actionChooseService": "Choose what you need",
  "owner.actionConfirm": "Confirm your details",
  "owner.actionDelegate": "Bring in colleagues",
  "owner.actionStatus": "See where this stands",
  "owner.heading": "What would you like to do?",
  "owner.roleContributor": "You have been asked to help with this engagement.",
  "owner.roleExplainer": "You own this engagement. You can answer the questions yourself, bring in colleagues, or both.",
  "owner.submitOnlyYou": "Only you can submit this engagement, whoever helps answer it.",
  "progress.branch.remaining": "About {count} more questions",
  "progress.branch.section": "Section {index} of {total} in this area",
  "progress.nav.label": "Form progress",
  "progress.phase.aboutYou": "About you",
  "progress.phase.branchDetails": "Your {branch} details",
  "progress.phase.reviewSubmit": "Review & submit",
  "progress.phase.whatToAssess": "What to assess",
  "questionnaire.contact.email": "Email",
  "questionnaire.contact.name": "Name",
  "questionnaire.contact.phone": "Phone",
  "questionnaire.contact.role": "Role",
  "questionnaire.crossBranch.heading": "Based on your answers, we recommend also covering {branch} — include it?",
  "questionnaire.crossBranch.notSureNote": "We'll flag this for your consultant to confirm with you.",
  "questionnaire.dateRange.from": "From",
  "questionnaire.dateRange.to": "To",
  "questionnaire.deadEnd.postIncidentTerminal.callNow": "Call now:",
  "questionnaire.deadEnd.postIncidentTerminal.fallback": "24×7 fallback:",
  "questionnaire.deadEnd.postIncidentTerminal.hours24x7": "answered 24×7",
  "questionnaire.deadEnd.postIncidentTerminal.hoursStated": "answered {hours}",
  "questionnaire.deadEnd.postIncidentTerminal.pending": "Incident response is handled differently from a scheduled engagement. The direct route to a person is being finalised — a member of the team will contact you as a priority.",
  "questionnaire.deadEnd.postIncidentTerminal.staffedBy": "staffed by {staffedBy}",
  "questionnaire.deadEnd.postIncidentTerminal.statement": "Incident response is handled differently from a scheduled engagement. Please call now — do not describe the incident in writing first.",
  "questionnaire.dontKnow": "I don't know",
  "questionnaire.fileUpload.add": "Attach a document",
  "questionnaire.fileUpload.failed": "That file could not be uploaded. Try again, or continue without it and mention it to your consultant.",
  "questionnaire.fileUpload.limit": "Up to {mb} MB per file. Every file is virus-scanned before a consultant can open it.",
  "questionnaire.fileUpload.none": "No files uploaded yet.",
  "questionnaire.fileUpload.status.blocked": "Blocked — this file failed the virus scan and was removed.",
  "questionnaire.fileUpload.status.clean": "Clean",
  "questionnaire.fileUpload.status.pending": "Scanning…",
  "questionnaire.fileUpload.tooLarge": "That file is too large to attach. Send it to your consultant directly.",
  "questionnaire.fileUpload.uploading": "Uploading…",
  "questionnaire.no": "No",
  "questionnaire.notSure": "Not sure",
  "questionnaire.reconfirm": "You answered this earlier — still correct?",
  "questionnaire.repeatComplete": "complete",
  "questionnaire.repeatInstance": "Instance {number}",
  "questionnaire.repeatInstanceSelect": "Choose instance",
  "questionnaire.required": "This question needs an answer before you can submit.",
  "questionnaire.saved": "Saved {time}",
  "questionnaire.sectionEdit": "Edit",
  "questionnaire.sectionInProgress": "In progress",
  "questionnaire.sectionLocked": "Unlocks after this section",
  "questionnaire.sectionSummary": "{answered} answered · {notSure} not sure",
  "questionnaire.sectionsAdded": "New section(s) added: {titles}",
  "questionnaire.selectPlaceholder": "Choose…",
  "questionnaire.submit": "Submit",
  "questionnaire.submit.failed": "This could not be submitted just now. Your answers are saved. Try again in a moment.",
  "questionnaire.submit.incomplete": "This could not be submitted yet: some required questions are still unanswered.",
  "questionnaire.submit.stillOpen": "Still to answer",
  "questionnaire.submit.submitting": "Submitting…",
  "questionnaire.submitErrors": "{count} question(s) need an answer before you can submit.",
  "questionnaire.yes": "Yes",
  "review.attention": "Needs your attention",
  "review.emptyAll": "Nothing outstanding — you're ready to submit.",
  "review.eyebrow": "Almost there",
  "review.forwarded": "Forwarded, not yet answered",
  "review.introCounts": "{answered} of {total} questions answered. Resolve what you can — anything marked not sure is confirmed with your consultant, never dropped.",
  "review.notSure": "Marked not sure",
  "review.nudge": "Nudge",
  "review.readyBody": "Submitting commits every participant's answers for NIMER review. Only you, as the owner, can submit.",
  "review.readyTitle": "Ready when you are.",
  "review.statusActive": "active",
  "review.statusInvited": "invited",
  "review.submit": "Submit engagement scope",
  "review.viewAll": "View all answers",
  "scope.panel.announce.moved": "{label} moved to {group}.",
  "scope.panel.empty": "Answer a few questions and we will show what is likely in scope here.",
  "scope.panel.footer": "A NIMER consultant confirms this scope with you before your techno-commercial proposal is prepared.",
  "scope.panel.group.clarify": "We need to check",
  "scope.panel.group.gone": "No longer indicated",
  "scope.panel.group.inferred": "We recommend also including",
  "scope.panel.group.stated": "Based on what you told us",
  "scope.panel.heading": "Likely engagement scope",
  "scope.panel.labelUnavailable": "Label unavailable — service catalogue not loaded",
  "scope.panel.live": "Live",
  "scope.panel.reason.generic": "No longer indicated — this can change as you answer more questions.",
  "scope.panel.reason.notRequested": "Because you told us {label} is out of scope.",
  "secrets.badge": "Notice",
  "secrets.body": "Do not submit passwords, private keys, API secrets or production credentials through this portal. Test credentials are exchanged out of band once the engagement is authorised.",
  "secrets.heading": "Never send credentials through this portal",
  "secrets.inline": "This section accepts free text — never include passwords, keys, or live credentials.",
  "service.confirm": "Confirm",
  "service.failed": "That could not be saved. Refresh the page and try again.",
  "service.heading": "What do you need?",
  "service.intro": "Choose the service closest to what you are trying to achieve. A NIMER consultant will confirm it with you.",
  "service.statusBody": "A NIMER consultant is working on this engagement and will be in touch. There is nothing for you to answer here yet.",
  "service.statusEyebrow": "Your engagement",
  "service.statusHeading": "With your consultant",
  "service.statusRef": "Quote {ref} if you get in touch.",
  "shell.signedInAs": "Signed in as {email}",
  "shell.skipToContent": "Skip to content",
  "shell.tagline.customer": "Engagement scoping",
  "shell.tagline.staff.admin": "Administration",
  "shell.tagline.staff.consultant": "Consultant console",
  "signIn.customer.accessLabel": "Customer access",
  "signIn.customer.body": "Enter the email address the engagement request was sent to and we will send you a sign-in code.",
  "signIn.customer.codeBody": "Enter the 6-digit code we sent to {email}.",
  "signIn.customer.codeLabel": "Sign-in code",
  "signIn.customer.emailLabel": "Email address",
  "signIn.customer.error.codeInvalid": "That code is not valid. Check it and try again.",
  "signIn.customer.error.generic": "Something went wrong. Try again.",
  "signIn.customer.error.locked": "Too many attempts. Request a new code.",
  "signIn.customer.error.rateLimited": "Too many attempts. Wait a moment and try again.",
  "signIn.customer.heading": "Sign in to continue",
  "signIn.customer.resend": "Send a new code",
  "signIn.customer.resendCountdown": "Resend in {time}",
  "signIn.customer.sendCode": "Send code",
  "signIn.customer.verifyCode": "Verify code",
  "signIn.staff.action": "Sign in with your NIMER account",
  "signIn.staff.body": "This area is for NIMER staff. Sign in with your NIMER account.",
  "signIn.staff.heading": "Staff sign-in",
  "submitConfirm.answered": "answered",
  "submitConfirm.back": "Go back",
  "submitConfirm.contributors": "contributors",
  "submitConfirm.next1": "A NIMER consultant reviews the derived scope.",
  "submitConfirm.next2": "We may come back with targeted clarifications — only the affected questions reopen.",
  "submitConfirm.next3": "Nothing is priced until the scope is confirmed with you, and your techno-commercial proposal follows from it.",
  "submitConfirm.nextTitle": "What happens next",
  "submitConfirm.notSure": "marked not sure",
  "submitConfirm.title": "Submit this engagement scope?",
  "welcome.begin": "Begin",
  "welcome.caution": "Never include passwords, keys or live credentials in your answers.",
  "welcome.dontShow": "Don't show this again",
  "welcome.eyebrow": "Before you begin",
  "welcome.step1.body": "Your organisation, sector and a contact.",
  "welcome.step1.title": "About you.",
  "welcome.step2.body": "Plain language — no service names needed.",
  "welcome.step2.title": "What you need.",
  "welcome.step3.body": "Scoped to what you need. Forward any of them to a colleague.",
  "welcome.step3.title": "A few questions.",
  "welcome.step4.body": "A consultant confirms scope before your proposal is priced.",
  "welcome.step4.title": "Review & submit.",
  "welcome.title": "Four steps to a confirmed scope.",
  "wiz.added": "{n} added — you chose {trigger}",
  "wiz.addedAnnounce": "{n} sections added",
  "wiz.answeredOf": "{answered} of {total} answered",
  "wiz.back": "Back",
  "wiz.chapterAdded": "{title} added — you chose {trigger}",
  "wiz.continue": "Continue",
  "wiz.finish": "Finish",
  "wiz.forwardSection": "Forward section",
  "wiz.kicker": "Chapter {n} · {title}",
  "wiz.markedNotSure": "Marked as not sure",
  "wiz.partOf": "Part {i} of {k}",
  "wiz.phase.completed": ", completed",
  "wiz.phase.current": ", current phase",
  "wiz.phase.future": ", upcoming",
  "wiz.progress": "Section {n} of {m}",
  "wiz.progressGrows": "Section {n} of {m} · grows as scope opens",
  "wiz.review": "Review",
  "wiz.reviewHeading": "Review and submit.",
  "wiz.saveError": "Couldn't save — retrying",
  "wiz.saved": "Saved just now",
  "wiz.saving": "Saving…",
  "wiz.scopeSoFar": "Indicative scope · {n} services",
  "wiz.scopeSoFar.one": "Indicative scope · 1 service",
  "wiz.sections": "Questionnaire sections",
  "wiz.sectionsPanel": "Sections",
  "wiz.showAll": "Show all sections",
  "wiz.state.attention": ", needs attention",
  "wiz.state.current": ", current",
  "wiz.state.done": ", completed",
  "wiz.state.forwarded": ", forwarded",
  "wiz.state.partial": ", in progress",
  "wiz.state.todo": ", not started",
  "wiz.topbarProgress": "{n} of {m}",
  "wiz.undo": "Undo",
  "wiz.workListDone": "All questions forwarded to you are answered."
}
